import api from "./api";

const buildQueryParams = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.fromDate) queryParams.append("fromDate", params.fromDate);
  if (params.toDate) queryParams.append("toDate", params.toDate);
  if (params.statusCode) queryParams.append("statusCode", params.statusCode);
  if (params.productVerticalCode)
    queryParams.append("productVerticalCode", params.productVerticalCode);
  if (params.countryCode) queryParams.append("countryCode", params.countryCode);
  if (params.zoneCode) queryParams.append("zoneCode", params.zoneCode);
  if (params.regionCode) queryParams.append("regionCode", params.regionCode);
  if (params.territoryCode)
    queryParams.append("territoryCode", params.territoryCode);
  const cc =
    params.complaintCategory != null
      ? String(params.complaintCategory).trim()
      : "";
  if (cc) queryParams.append("complaintCategory", cc);
  const marketCode =
    params.marketCode != null ? String(params.marketCode).trim() : "";
  if (marketCode) queryParams.append("marketCode", marketCode);
  if (params.pageNumber != null)
    queryParams.append("pageNumber", params.pageNumber);
  if (params.pageSize != null) queryParams.append("pageSize", params.pageSize);
  return queryParams;
};

export const domesticReportAPI = {
  getData: async (params = {}) => {
    const queryParams = buildQueryParams(params);
    const response = await api.get(
      `/api/domestic-reports/data${
        queryParams.toString() ? `?${queryParams}` : ""
      }`
    );
    return response.data;
  },
};
